var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFlash = function SvgFlash(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 37",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.897 14.289 16.99.728a.501.501 0 0 0-.162-.538.51.51 0 0 0-.719.062L.858 18.657l10.279 4.038-4.109 13.557a.51.51 0 0 0 .88.476l15.191-18.37-10.202-4.069Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFlash);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMzciIGZpbGw9ImN1cnJlbnRDb2xvciIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIuODk3IDE0LjI4OSAxNi45OS43MjhhLjUwMS41MDEgMCAwIDAtLjE2Mi0uNTM4LjUxLjUxIDAgMCAwLS43MTkuMDYyTC44NTggMTguNjU3bDEwLjI3OSA0LjAzOC00LjEwOSAxMy41NTdhLjUxLjUxIDAgMCAwIC44OC40NzZsMTUuMTkxLTE4LjM3LTEwLjIwMi00LjA2OVoiLz48L3N2Zz4=";